import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", id: "nav-home-link" },
  { to: "/reviews", label: "Theatre Reviews", id: "nav-reviews-link" },
  { to: "/blog", label: "Blog & Resources", id: "nav-blog-link" },
  { to: "/gallery", label: "Gallery", id: "nav-gallery-link" },
  { to: "/minds-chaos", label: "Mind's Chaos (TIE)", id: "nav-minds-chaos-link" },
  { to: "/contact", label: "Book a Session", id: "nav-contact-link" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-shadow duration-300 backdrop-blur-xl bg-[#F7F5F0]/80 ${
        scrolled ? "border-b border-[#1A1A1A]/5 shadow-sm" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif-display text-2xl md:text-3xl tracking-tight text-[#1A1A1A]">
            Jack Pritchard
          </span>
          <span className="label-caps text-[0.6rem] text-[#7A1C28] mt-0.5 whitespace-nowrap">
            Drama · Voice · Coaching
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={`label-caps text-[0.7rem] transition-colors hover:text-[#7A1C28] ${
                pathname === l.to ? "text-[#7A1C28]" : "text-[#1A1A1A]"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#1A1A1A]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#F7F5F0] border-t border-[#E5E2D9] px-6 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`${l.id}-mobile`}
              onClick={() => setOpen(false)}
              className="label-caps text-sm text-[#1A1A1A] hover:text-[#7A1C28]"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
